import ApiService from "@/core/services/api.service";
import { SET_PAGE_LOADING } from "@/core/services/store/config.module";

// action types
export const UPDATE_TABLE_STRUCTURE =
  "getSKIPPEDFULFILLMENTTASKSSTableStructure";
export const UPDATE_TABLE_DATA = "getSKIPPEDFULFILLMENTTASKSSTableData";
export const EXPORT_TABLE_DATA = "exportSKIPPEDFULFILLMENTTASKSSTableData";

// mutation types
export const SET_TABLE_STRUCTURE = "setSKIPPEDFULFILLMENTTASKSSTableStructure";
export const SET_TABLE_DATA = "setSKIPPEDFULFILLMENTTASKSSTableData";
export const SET_TABLE_FILTER = "setSKIPPEDFULFILLMENTTASKSSTableFilter";
export const SET_TABLE_PAGE = "setSKIPPEDFULFILLMENTTASKSSTablePage";
export const SET_TABLE_PERPAGE = "setSKIPPEDFULFILLMENTTASKSSTablePerPage";
export const SET_TABLE_SORTBY = "setSKIPPEDFULFILLMENTTASKSSTableSortBy";
export const SET_TABLE_SORTORDER = "setSKIPPEDFULFILLMENTTASKSSTableSortOrder";
export const SET_EXPORT_LINK = "setSKIPPEDFULFILLMENTTASKSSExportLink";
export const SET_FILTERS_DATA = "setSKIPPEDFULFILLMENTTASKSSFiltersData";

const state = {
  export_link: null,
  table_structure: {},
  table_data: {},
  filters_data: [],
  table_state: {
    page: 1,
    per_page: 50,
    sortBy: "id",
    sortOrder: "desc",
    filters: [],
  },
};

const getters = {
  getSKIPPEDFULFILLMENTTASKSSTableProperties(state) {
    return state.table_structure.properties;
  },
  getSKIPPEDFULFILLMENTTASKSSTablePermissions(state) {
    return state.table_structure.permissions;
  },
  getSKIPPEDFULFILLMENTTASKSSTableState(state) {
    // console.log("table state is ", state.table_state);
    return state.table_state;
  },
  getSKIPPEDFULFILLMENTTASKSSTableHeaders(state) {
    return state.table_structure.columns;
  },
  getSKIPPEDFULFILLMENTTASKSSTableFilters(state) {
    return state.table_structure.filters;
  },
  getSKIPPEDFULFILLMENTTASKSSTableData(state) {
    return state.table_data.data;
  },
  getSKIPPEDFULFILLMENTTASKSSExportUrl(state) {
    return state.export_link;
  },
  getSKIPPEDFULFILLMENTTASKSSUploadType(state) {
    return state.table_structure.types;
  },
  getSKIPPEDFULFILLMENTTASKSSExampleFiles(state) {
    return state.table_structure.example_file;
  },
};

const actions = {
  [UPDATE_TABLE_STRUCTURE](context) {
    return new Promise((resolve) => {
      ApiService.post("/warehouse_management/skipped_fulfillment_tasks")
        .then(({ data }) => {
          context.commit(SET_TABLE_STRUCTURE, data);
          resolve(data);
        })
        .catch((data) => {
          context.commit(SET_PAGE_LOADING, false);
          resolve(data);
        });
    });
  },
  [UPDATE_TABLE_DATA](context, payload) {
    context.commit(SET_PAGE_LOADING, true);
    return new Promise((resolve) => {
      ApiService.post(
        "/warehouse_management/skipped_fulfillment_tasks/datatable",
        payload
      )
        .then(({ data }) => {
          context.commit(SET_TABLE_DATA, data);
          resolve(data);

          context.commit(SET_PAGE_LOADING, false);
          setTimeout(() => {
            window.scrollTo(0, 0);
          }, 100);
        })
        .catch((data) => {
          context.commit(SET_PAGE_LOADING, false);
          resolve(data);
        });
    });
  },
  [EXPORT_TABLE_DATA](context, payload) {
    context.commit(SET_PAGE_LOADING, true);
    return new Promise((resolve) => {
      ApiService.post(
        "/warehouse_management/skipped_fulfillment_tasks/export",
        payload
      )
        .then(({ data }) => {
          context.commit(SET_EXPORT_LINK, data.url);
          resolve(data);
        })
        .catch((data) => {
          context.commit(SET_PAGE_LOADING, false);
          resolve(data);
        });
    });
  },
};

const mutations = {
  [SET_FILTERS_DATA](state, filter_data) {
    state.filters_data = filter_data;
  },
  [SET_TABLE_FILTER](state, filter) {
    state.table_state.filters = filter;
  },
  [SET_TABLE_PAGE](state, page) {
    state.table_state.page = page;
  },
  [SET_TABLE_PERPAGE](state, perPage) {
    state.table_state.per_page = perPage;
  },
  [SET_TABLE_SORTBY](state, sortBy) {
    state.table_state.sortBy = sortBy;
  },
  [SET_TABLE_SORTORDER](state, sortOrder) {
    state.table_state.sortOrder = sortOrder;
  },
  [SET_TABLE_STRUCTURE](state, table_structure) {
    state.table_structure = table_structure.data;
  },
  [SET_TABLE_DATA](state, table_data) {
    state.table_data = table_data;
  },
  [SET_EXPORT_LINK](state, link) {
    state.export_link = link;
  },
};

export default {
  state,
  actions,
  mutations,
  getters,
};
